import { type CSSProperties as ReactCSSProperties } from 'react';

export const DefaultTableStyles = {
  Table: {
    borderSpacing: '0 12px',
    borderCollapse: 'separate',
  } as ReactCSSProperties,
  TableHeader: {
    HiresCol: {
      textAlign: 'center',
      width: '20%',
    } as ReactCSSProperties,
    JobsCol: {
      paddingLeft: 40,
      textAlign: 'left',
    } as ReactCSSProperties,
    StatusCol: {
      textAlign: 'left',
      width: '20%',
    } as ReactCSSProperties,
  },
};

export const DraftTableStyles = {
  Table: {
    borderSpacing: '0 12px',
    borderCollapse: 'separate',
  } as ReactCSSProperties,
  TableHeader: {
    ActionCol: {
      textAlign: 'left',
      width: '20%',
    } as ReactCSSProperties,
    HiresCol: {
      textAlign: 'center',
      width: '25%',
    } as ReactCSSProperties,
    JobsCol: {
      paddingLeft: 40,
      textAlign: 'left',
    } as ReactCSSProperties,
    StatusCol: {
      textAlign: 'left',
      width: '20%',
    } as ReactCSSProperties,
  },
};
